import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as searchReducer, REDUCER_NAME as SEARCH_REDUCER } from './search'

const reducer = combineReducers({
    [SEARCH_REDUCER]: searchReducer
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/voucher/state/index.js